import { LOCAL_KEY } from '~/constants/config'

// localstorage
export const localSetItem = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value))
}

export const localGetItem = (key: string) => {
  const res = localStorage.getItem(key)

  if (res) {
    return JSON.parse(res)
  }
  return undefined
}

export const localDeleteItem = (key: string) => {
  localStorage.removeItem(key)
}

// sessionstorage
export const sessionSetItem = (key: string, value: any) => {
  sessionStorage.setItem(key, JSON.stringify(value))
}

export const sessionRemoveItem = (key: string) => {
  sessionStorage.removeItem(key)
}

export const sessionGetItem = (key: string) => {
  const res = sessionStorage.getItem(key)

  if (res) {
    try {
      return JSON.parse(res)
    } catch (error) {
      return res
    }
  }
  return undefined
}

// 通知编辑器是从新建过去
// https://rsjqcmnt5p.feishu.cn/wiki/KEbMwoS3OizyzrkqNvScMv9gnG9 跳转约定文档地址
export const sendEditorInfo = (key: string) => {
  localStorage.setItem(LOCAL_KEY.CREATE_WORK, key)
}
